export default {"src":"/_next/static/media/0xba2ae424d960c26247dd6c32edc70b295c744c43.e3e39360.svg","height":1875,"width":1875,"blurWidth":0,"blurHeight":0};